import { fetchProducts, fetchCategories } from '../../services/products'

const state = {
    products: [],
    categories: [],
    filter: null,
}

const getters = {}

const actions = {
    async fetchAllProducts({ commit }) {
        const products = await fetchProducts();
        commit('SET_ALL_PRODUCTS', products.data)
    },

    async fetchAllCategories({ commit }) {
        const categories = await fetchCategories();
        commit('SET_ALL_CATEGORIES', categories.data)
    },

    setFilter({ commit }, value) {
        commit('SET_FILTER', value)
        window.scrollTo(0, getOffset(document.getElementsByClassName('content')[0]).top);
    }
}

function getOffset( el ) {
    var _x = 0;
    var _y = 0;
    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
    }
    return { top: _y, left: _x };
}

const mutations = {
    SET_ALL_PRODUCTS: (state, value) => {
        state.products = value
    },
    SET_ALL_CATEGORIES: (state, value) => {
        state.categories = value
    },
    SET_FILTER: (state, value) => {
        state.filter = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  